import jsPDF from 'jspdf'
export default  {
    methods: {
        async exportAllItems(items){
            let doc = new jsPDF('', 'pt','a4');
            let y =20;
            let ratio=1.0*595.28;
            for (let item of items){
                if(y>800){
                    doc.addPage()
                    y=20
                }
                let img=null;
                if(item.$refs.dygraphplot){
                    img = item.$refs.dygraphplot.toImage()
                    doc.addImage(img, 'JPEG', 0, y,
                        ratio,
                        ratio/item.$refs.dygraphplot.$refs.graphdiv.clientWidth*item.$refs.dygraphplot.$refs.graphdiv.clientHeight)
                    y=y+ratio/item.$refs.dygraphplot.$refs.graphdiv.clientWidth*item.$refs.dygraphplot.$refs.graphdiv.clientHeight+20;
                } else if (item.$refs.plotly){
                    img =  await item.$refs.plotly.toImage()
                    doc.addImage(img, 'JPEG', 0, y,
                        ratio,
                        ratio/item.$refs.plotly.$refs.container.clientWidth*item.$refs.plotly.$refs.container.clientHeight
                    )
                    y=y+ratio/item.$refs.plotly.$refs.container.clientWidth*item.$refs.plotly.$refs.container.clientHeight+20;
                } else if (item.$refs.container){
                    img =  await item.toImage()
                    doc.addImage(img, 'JPEG', 0, y,
                        ratio,
                        ratio/item.$refs.container.clientWidth*item.$refs.container.clientHeight
                    )
                    y=y+ratio/item.$refs.container.clientWidth*item.$refs.container.clientHeight+20;
                }
            }
            doc.save("export.pdf")

        }
    }
};